module.exports = __webpack_public_path__ + "img/duo_cisco_msg.e13f8ac8.png";